import React from "react";
import { Field, reduxForm } from "redux-form";
import { connect } from "react-redux";
import {
  processFormValuesPost,
  renderFormInput,
} from "../../modules/formTools";
import { Input, ReadOnly } from "../Form";
import { ButtonBlack } from "../Button";
import Loading from "../Loading";
import { minLength, required } from "../../modules/validation";

const mapStateToProps = props => {
  let user_type_id = 1;
  if (props.userInvite.userInvite && props.userInvite.userInvite.agency) {
    user_type_id = 2;
  }
  if (props.userInvite.userInvite && props.userInvite.userInvite.hotelGroup) {
    user_type_id = 6;
  }
  return {
    initialValues: {
      ...props.userInvite.userInvite,
      user_type_id: user_type_id,
    },
    user_type_id: user_type_id,
  };
};

const v = {
  firstName: required("Please enter your first name"),
  surname: required("Please enter your surname"),
  email: required("Please enter your email address"),
  password: required("Please enter your password"),
  min8: minLength(8),
};

const UserInvitedForm = props => {
  const onSubmit = formValues => {
    return processFormValuesPost(props, formValues, props.initialValues);
  };
  return (
    <div className={"bg-off-white p-5 mb-5"}>
      <div>
        <form onSubmit={props.handleSubmit(onSubmit)}>
          <div className="bg-off-white p-5 mb-5">
            <Field
              name={"email"}
              disabled={true}
              label={"Email"}
              component={ReadOnly}
            />
            {!props.userInvite.is_existing_user ? (
              <>
                <Field
                  name={"first_name"}
                  label={"First Name"}
                  component={renderFormInput}
                />
                <Field
                  name={"surname"}
                  label={"Surname"}
                  component={renderFormInput}
                />
                <div className="hidden">
                  <Field name={"user_type_id"} component={renderFormInput} />
                </div>
                <Field
                  name="password"
                  type="password"
                  validate={(v.password, v.min8)}
                  label="Password"
                  component={Input}
                />
              </>
            ) : null}

            <ButtonBlack type="submit">
              {props.submitting ? (
                <Loading inline />
              ) : props.userInvite.is_existing_user &&
                props.userInvite.company ? (
                "Join Company"
              ) : (
               props.user_type_id === 6 ? "Join" : "Register"
              )}
            </ButtonBlack>

            <p className={'my-2'}>
              Click to view our{" "}
              <a
                target={"_blank"}
                rel={"noopener noreferrer"}
                href={`${window.WORDPRESS_URL || ""}/privacy`}
              >
                privacy policy
              </a>
              .
            </p>
          </div>
        </form>
      </div>
    </div>
  );
};

export default connect(
  mapStateToProps,
  null
)(
  reduxForm({
    form: "userInvitedForm",
    enableReinitialize: true,
  })(UserInvitedForm)
);
